export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
